module.exports = __webpack_public_path__ + "static/launch-darkly-logo-d82638ff267c9705b9bae3161fcb51a0.png";